/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Revoke_SuccessInputs */

const vi_api_keys_revoke_success = /** @type {(inputs: Api_Keys_Revoke_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thu hồi khóa`)
};

/**

* @param {Api_Keys_Revoke_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_revoke_success = /** @type {((inputs?: Api_Keys_Revoke_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Revoke_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_revoke_success(inputs)
});